// material-ui
import useMediaQuery from "@mui/material/useMediaQuery";

// project imports
import DrawerHeaderStyled from "./DrawerHeaderStyled";
import Logo from "components/logo";

import useConfig from "hooks/useConfig";
import { MenuOrientation } from "config";

interface Props {
  open: boolean;
}

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }: Props) {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  const { menuOrientation } = useConfig();
  const isHorizontal =
    menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        minHeight: isHorizontal ? "unset" : "60px",
        width: isHorizontal ? { xs: "100%", lg: "424px" } : "100%",
        paddingTop: isHorizontal ? { xs: "10px", lg: "0" } : "24px",
        paddingBottom: isHorizontal ? { xs: "18px", lg: "0" } : "8px",
        paddingLeft: isHorizontal ? { xs: "24px", lg: "0" } : 0,
        justifyContent: isHorizontal ? "flex-start" : "center",
        mt: isHorizontal ? 0 : 1,
      }}
    >
      <Logo isIcon={!open} sx={{ width: open ? "auto" : 35, height: 35 }} />
    </DrawerHeaderStyled>
  );
}
